export default __webpack_public_path__ + "static/media/delete.b35bbeb4.svg";